/* eslint-disable */
import React from 'react';
import Deck from "../Deck";
import Hand from "./hand.jsx";

const Board = function (props) {
    const {
        roomId,
        topCards ,
        bottomCards ,
        trump,
        boardWinnerId,
        bottomPlayerId,
        topPlayerId,
        playedCards,
        activePlayerId,
        hiddenBitaCards,
        selectedCombinationCards,
        cardsSelectable,
        publishedCombinationCards,
        isViewRoom,
        resetHand,
        playShuffle,
        playCardBita,
        playCardSound
    } = props;

    return (
        <div>
            <Hand
                roomId={roomId}
                cards={topCards}
                isBottom={false}
                activeHand={activePlayerId === topPlayerId}
                playedCard={playedCards?.find(c => c.platformId === topPlayerId)?.index }
                playerId={topPlayerId}
                boardWinnerId={boardWinnerId}
                hiddenBitaCards={hiddenBitaCards?.[topPlayerId]}
                selectedCombinationCards={{}}
                publishedCombinationCards={publishedCombinationCards?.[topPlayerId] || {}}
                cardsSelectable={false}
                isViewRoom={isViewRoom}
                resetHand={resetHand}
                playShuffle={playShuffle}
                playCardBita={playCardBita}
                playCardSound={playCardSound}
            />
            <Deck offeredCard={trump?.offeredCard} isVisible={trump?.visibleOnDeck && !resetHand}/>
            <Hand
                roomId={roomId}
                cards={bottomCards}
                isBottom={true}
                activeHand={activePlayerId === bottomPlayerId}
                playedCard={playedCards?.find(c => c.platformId === bottomPlayerId)?.index}
                playerId={bottomPlayerId}
                boardWinnerId={boardWinnerId}
                isViewRoom={isViewRoom}
                hiddenBitaCards={hiddenBitaCards?.[bottomPlayerId]}
                selectedCombinationCards={selectedCombinationCards || {}}
                publishedCombinationCards={isViewRoom ? publishedCombinationCards?.[bottomPlayerId] : {}}
                cardsSelectable={cardsSelectable}
                resetHand={resetHand}
                playShuffle={playShuffle}
                playCardBita={playCardBita}
                playCardSound={playCardSound}
            />
        </div>

    );
}

export default Board;
